// @ts-nocheck

import React, { useEffect, useRef, useState } from "react";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { FormInputSectionComponent } from "../../Components/FormInputSectionComponent/FormInputSectionComponent";
import "./SelectBranchInput.scss";
import { getBranchCode } from "../../../CommonFunction/GetUserInfo";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ClearFields, updateSingleField } from "../../Components/FormInputSectionComponent/formUtils";
import { ClearSpecificForm } from "../../../Store/FormDataReducer/FormFieldFunctions";
const Loadfilds = [
  {
    id: Math.random() * 10,
    name: "Select_Branch",
    fields: [
      {
        id: Math.random() * 10,
        name: "Branch_Code",
        label: "No Label",
        type: "InputDropForQuery",
        masterName: "user_Branch",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

const SelectBranchInput = ({ Form_Key, TypeOfPortal }) => {
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const formRef = useRef({});
  console.log(formRef, Form_Key);
  const [FormData, setFormdata] = useState<any>({});

  useEffect(() => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code) {
      let data = FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code;

      let BranchObj = {
        BranchCode: data?.Unique_Id,
        Name: data?.Name,
        id: data?._id,
      };

      updateSingleField(formRef, "Branch_Code", FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code?.Name);
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify(BranchObj));
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code]);

  useEffect(() => {
    if (TypeOfPortal.includes("Add")) {
      console.log(TypeOfPortal);
      const fetchBranchCode = async () => {
        try {
          const BranchData = await getBranchCode();

          let newBranch = {
            Name: BranchData?.Name,
            BranchCode: BranchData?.BranchCode,
            _id: BranchData?.id,
            Search_Value: BranchData?.Search_Value,
          };
          console.log(newBranch);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Branch_Code: newBranch,
              },
            },
          });

          updateSingleField(formRef, "Branch_Code", BranchData?.Name);
        } catch (error) {
          console.error("Error fetching branch code:", error);
        }
      };

      fetchBranchCode();
    }
  }, [TypeOfPortal]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  return (
    <div className="formContainerSearchInput">
      {Loadfilds &&
        TypeOfPortal &&
        Loadfilds.map((e) => {
          return (
            <div key={e.id} className="SelectBranchInput">
              <FormInputSectionComponent
                inputfields={
                  TypeOfPortal && TypeOfPortal?.includes("Edit") ? [{ ...e.fields[0], disabled: true }] : e.fields
                }
                Type={e.name}
                onhandleFormikChange={HanldeChangeonForm}
                validation_Schema={{}}
                onErrorsChange={() => {}}
                formkey={Form_Key}
                formRef={formRef}
              />
            </div>
          );
        })}
    </div>
  );
};

export default SelectBranchInput;
